import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../App';
import { Bell, X } from 'lucide-react';
import { format } from 'date-fns';

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchNotifications = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/notifications`);
      setNotifications(response.data);
      setUnreadCount(response.data.filter(n => !n.read).length);
    } catch (err) {
      console.error('fetchNotifications failed', err);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, [fetchNotifications]);

  const markAsRead = async (notifId) => {
    try {
      await axios.put(`${API}/notifications/${notifId}/read`);
      fetchNotifications();
    } catch (err) {
      console.error('markAsRead failed', err);
    }
  };

  const deleteNotification = async (notifId) => {
    try {
      await axios.delete(`${API}/notifications/${notifId}`);
      fetchNotifications();
    } catch (err) {
      console.error('deleteNotification failed', err);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="relative p-2 text-[#8B2E3C] hover:bg-[#FBF4EA] rounded-lg transition-colors"
        data-testid="notification-bell"
      >
        <Bell className="w-5 h-5" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-[#8B2E3C] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
            {unreadCount}
          </span>
        )}
      </button>

      {showDropdown && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setShowDropdown(false)} />
          <div className="absolute right-0 mt-2 w-80 sm:w-96 bg-white rounded-lg shadow-xl border-2 border-[#E9DDCF] z-50 max-h-96 overflow-y-auto">
            <div className="p-4 border-b border-[#E9DDCF]">
              <h3 className="font-bold text-lg">Notifications</h3>
            </div>
            {notifications.length === 0 ? (
              <div className="p-6 text-center text-[#666666]">
                No notifications
              </div>
            ) : (
              <div>
                {notifications.map((notif) => (
                  <div
                    key={notif.id}
                    className={`p-4 border-b border-[#E9DDCF] hover:bg-[#FBF4EA] transition-colors ${
                      !notif.read ? 'bg-[#FFF9F0]' : ''
                    }`}
                    data-testid={`notification-${notif.id}`}
                  >
                    <div className="flex justify-between items-start gap-2">
                      <div className="flex-1">
                        <p className={`text-sm ${!notif.read ? 'font-medium' : ''}`}>
                          {notif.message}
                        </p>
                        <p className="text-xs text-[#666666] mt-1">
                          {format(new Date(notif.created_at), 'MMM d, h:mm a')}
                        </p>
                      </div>
                      <button
                        onClick={() => deleteNotification(notif.id)}
                        className="text-[#999999] hover:text-[#8B2E3C] transition-colors"
                        data-testid={`delete-notification-${notif.id}`}
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                    {!notif.read && (
                      <button
                        onClick={() => markAsRead(notif.id)}
                        className="text-xs text-[#8B2E3C] hover:underline mt-2"
                        data-testid={`mark-read-${notif.id}`}
                      >
                        Mark as read
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationBell;
